module.exports = __webpack_public_path__ + "static/img/digg-icon.b31d0338.svg";